import O1HD from "../../../../engines/gameEngine";


// 本地数据基类
export class BaseLocalListData {
    
    lists = new Map();

    protected localKey: string = '';
    /** 额外增加需要保存的值，一般作用于json */
    protected extraAddBase: string[] = [];
    /** 额外增加需要保存的map值*/
    protected extraAddList: string[] = [];

    // 存储数据
    saveLocalData(bSaveList: boolean = true, blog: boolean = false) {
        let saveData = {};
        saveData['base'] = {};
        for (let k in this) {
            let o = this[k];
            let strType = typeof o;

            // cc.log('---- strType',strType,k)
            if ((strType != 'object' 
                || strType == 'object' && o instanceof Array
                || this.extraAddBase.indexOf(k) != -1
                ) 
                && strType != 'function' 
                && strType != 'symbol' 
                && k != 'localKey'
                && k != 'extraAddBase'
                ) 
            {
                saveData['base'][k] = o;
            }
        }

        if (bSaveList) {
            saveData['lists'] = this.getListJson('lists');
        }
        for (let k of this.extraAddList) {
            saveData[k] = this.getListJson(k);
        }
        if (blog) {
            cc.log('-------- save data    localKey = ', this.localKey);
            cc.log(saveData);
        }
        // cc.log('-------- saveData',JSON.stringify(saveData));
        let strData = JSON.stringify(saveData);
        O1HD.getServices().localStorageSrv.setStorage(this.localKey, strData);
    }

    getListJson(name: string) {
        if (!this[name]) {
            return {};
        }
        let saveData = {};
        this[name].forEach((v, k) => {
            saveData[k] = JSON.stringify(v);
        });
        return saveData;
    }

    createItem(key: number | string): object {
        return this.createItemT<Object>(Object, key);
    }

    createItemExtra(
        key: number | string
        , bList: boolean = true
        , extraName: string = null
    ): object {
        return this.createItemT<Object>(Object, key, bList);
    }


    createItemT<T>(typeT:{new ():T},key: number | string, bList: boolean = true): T {
        let build = new typeT();
        switch(typeof build['id']) {
            case 'number': {
                build['id'] = Number(key);
            }
            break;
            case 'string': {
                build['id'] = key + '';
            }
            break;
        }
        if (bList) {
            this.lists.set(build['id'], build);
        }
        return build;
    }

    // 加载数据
    loadLocalData(bLoadList: boolean = true, blog: boolean = false) {
        this.clearLists();
        let strdata = O1HD.getServices().localStorageSrv.getStorage(this.localKey);
        if (!strdata) {
            return;
        }
        let data = JSON.parse(strdata);
        if (blog) {
            cc.log('-------- load data    localKey = ', this.localKey);
            cc.log(data);
        }

        if (bLoadList && data['lists']) {
            for (let k in data['lists']) {
                // let item = this.createItem(parseInt(k));
                let item = this.createItem(k);
                Object.assign(item, JSON.parse(data['lists'][k]));
                // lists.set(parseInt(k), JSON.parse(data[k]))
            }
        }

        for (let o of this.extraAddList) {
            for (let k in data[o]) {
                // let item = this.createItemExtra(parseInt(k), false, o);
                let item = this.createItemExtra(k, false, o);
                if (!item) {
                    continue;
                }
                Object.assign(item, JSON.parse(data[o][k]));
                // this[o].set(parseInt(k), item);

                switch(typeof item['id']) {
                    case 'number': {
                        this[o].set(parseInt(k), item);
                    }
                    break;
                    case 'string': {
                        this[o].set(k, item);
                    }
                    break;
                }
                // lists.set(parseInt(k), JSON.parse(data[k]))
            }
        }

        if (data['base']) {
            for (let k in data['base']) {
                this[k] = data['base'][k];
            }
            // Object.assign(this, JSON.parse(data['base']));
        }
        // cc.log('--------  this', this.localKey, this,this.lists);
    }

    // 删除数据
    removeItem(key: number | string) {
        this.lists.delete(key);
    }

    /** 清空数据 */
    clearLists() {
        this.lists.clear();
    }
}
